import React from 'react';

export const TwoColumnLayout = ({ slots, spacingMultiplier = 1.0 }) => {
  const { header, main, sidebar, footer } = slots;
  
  return (
    <div 
      className="resume-layout-two-column" 
      style={{
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        minHeight: '100%',
        boxSizing: 'border-box',
        gap: `calc(var(--spacing-element-gap, 16px) * ${spacingMultiplier})`
      }}
    >
      {header && (
        <header className="resume-header-slot" style={{ gridColumn: '1 / -1' }}>
          {header}
        </header>
      )}

      <div 
        className="resume-columns-body" 
        style={{
          display: 'grid',
          gridTemplateColumns: 'var(--layout-sidebar-width, 240px) 1fr',
          gap: `calc(var(--layout-column-gap, 20px) * ${spacingMultiplier})`
        }}
      >
        <aside 
          className="resume-sidebar-slot"
          style={{
            background: 'var(--layout-sidebar-bg, transparent)',
            color: 'var(--layout-sidebar-text, inherit)',
            padding: 'var(--layout-sidebar-padding, 0)',
            borderRight: 'var(--layout-sidebar-border, none)',
            boxSizing: 'border-box',
            '--color-primary': 'var(--layout-sidebar-text, var(--color-primary))',
            '--color-secondary': 'var(--layout-sidebar-text, var(--color-secondary))',
            '--color-text-main': 'var(--layout-sidebar-text, var(--color-text-main))',
            '--color-text-light': 'var(--layout-sidebar-text, var(--color-text-light))',
            '--color-border': 'color-mix(in srgb, var(--layout-sidebar-text, var(--color-border)) 25%, transparent)',
          }}
        >
          {sidebar}
        </aside>
        
        <main className="resume-main-slot">
          {main}
        </main>
      </div>

      {footer && (
        <footer className="resume-footer-slot" style={{ gridColumn: '1 / -1' }}>
          {footer}
        </footer>
      )}
    </div>
  );
};
